module.exports = __webpack_public_path__ + "static/media/logo_branco.b4b379bb.png";